export default "__VITE_ASSET__frWY8LbJ__"